/* unplugin-vue-components disabled */import { render } from "./answerQuestions.vue?vue&type=template&id=c00e20ec&scoped=true&ts=true"
import script from "./answerQuestions.vue?vue&type=script&lang=ts"
export * from "./answerQuestions.vue?vue&type=script&lang=ts"

import "./answerQuestions.vue?vue&type=style&index=0&id=c00e20ec&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00e20ec"]])

export default __exports__